const EUROPE_POSTAL_PRICES = [
  { weight: 0.1, price: 12.9 },
  { weight: 0.25, price: 14 },
  { weight: 0.5, price: 22 },
  { weight: 0.75, price: 32 },
  { weight: 1, price: 35 },
  { weight: 1.25, price: 41 },
  { weight: 1.5, price: 43 },
  { weight: 1.75, price: 45.9 },
  { weight: 2, price: 47.9 },
];

const EUROPE_POSTAL_COUNTRIES = [
  "BE", // Belgium
  "CH", // Switzerland
  "CZ", // Czechia
  "DE", // Germany
  "DK", // Denmark
  "ES", // Spain
  "FI", // Finland
  "FR", // France
  "GB", // United Kingdom
  "GR", // Greece
  "HU", // Hungary
  "IE", // Ireland
  "IT", // Italy
  "LT", // Lithuania
  "LV", // Latvia
  "NL", // Netherlands
  "NO", // Norway
  "PL", // Poland
  "PT", // Portugal
  "RO", // Romania
  "SE", // Sweden
];

const US_POSTAL_PRICES = [
  { weight: 0.1, price: 13.9 },
  { weight: 0.25, price: 15.9 },
  { weight: 0.5, price: 22.9 },
  { weight: 0.75, price: 29.9 },
  { weight: 1, price: 35.9 },
  { weight: 1.25, price: 41.9 },
  { weight: 1.5, price: 48 },
  { weight: 1.75, price: 55 },
  { weight: 2, price: 61.9 },
];

export const POSTAL_PRICES = {
  US: US_POSTAL_PRICES,
  CA: US_POSTAL_PRICES.map((entry) => ({
    weight: entry.weight,
    // Peg CA prices to US prices but add $1 for weights 0.5kg and up
    price: entry.weight >= 0.5 ? entry.price + 1 : entry.price,
  })),
  ...Object.fromEntries(
    EUROPE_POSTAL_COUNTRIES.map((country) => [country, EUROPE_POSTAL_PRICES])
  ),
};
